import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/Why/Banner';
import Header from '../Components/Shared/Header/Header';
import Values from '../Components/Pages/AboutUs/Values';
import InnovativePart from '../Components/Pages/Home/Innovative';
import Prototyping from '../Components/Pages/Home/Prototyping';
import Forward from '../Components/Pages/Home/Forward';
import Features from '../Components/Pages/Home/Features';
import Design from '../Components/Pages/Home/Design';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
import Awards from '../Components/Shared/Awards/Awards';
import Bg from '../Assets/Cards/designDashboard.webp';
function Why(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Values />
        <InnovativePart />
        <Forward
        styles="forward-why"
         title="Cross company collaboration, solved"
        desc="Hostdesign becomes a central space for all of your design needs and brings your teams together through our collaboration features."
        desc1="Give your team and stakeholders full visibility across every project, add unique teams, create folders and leave design feedback as comments and annotations." />
        <Prototyping styles="reversed-prototyping"
         title="Easy Prototyping"
        desc="Transform your design mockups into interactive web or app prototypes without writing a single line of code." btn="Learn More"/>
         <Features />
         <Design backgroundImage={Bg}
        title="Design, test and ship amazing products at scale with HostDesign"
        desc="HostDesign Enterprise transforms your design process, leading to better products, faster"/>
         <Awards />
         <Start />
         <Footer/>
        </>
    )
};
export default Why ;